import React, { useState, useEffect } from 'react';
import axios from 'axios';

const NewsWidget = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const res = await axios.get('/api/finance-news');
                if (res.data && res.data.data) {
                    setNews(res.data.data);
                }
            } catch (error) {
                console.error("News error:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchNews();
    }, []);

    return (
        <div className="bento-card" style={{ fontFamily: '"Crimson Text", serif', display: 'flex', flexDirection: 'column' }}>
            <div style={{ borderBottom: '1px solid #ddd', paddingBottom: '10px', marginBottom: '15px' }}>
                <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 'bold' }}>Market Sentiment & Notes</h3>
                <span style={{ fontSize: '0.8rem', color: '#666', fontStyle: 'italic' }}>Curated Finance Feed</span>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', color: '#888', fontStyle: 'italic', padding: '20px' }}>Reading the tapes...</div>
            ) : news.length === 0 ? (
                <div style={{ padding: '20px', textAlign: 'center' }}>No news available right now.</div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', overflowY: 'auto' }}>
                    {news.map((item) => (
                        <a
                            key={item.uuid}
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                            className="news-item-hover"
                        >
                            <div style={{ border: '1px solid #eee', padding: '10px', borderRadius: '4px', background: '#fff' }}>
                                <h4 style={{ margin: '0 0 5px 0', fontSize: '1rem', fontWeight: '600', color: '#111' }}>{item.title}</h4>
                                <p style={{ margin: 0, fontSize: '0.85rem', color: '#444', lineHeight: '1.4', fontFamily: '"Inter", sans-serif' }}>
                                    {item.description ? (item.description.length > 100 ? item.description.substring(0, 100) + '...' : item.description) : 'No description available.'}
                                </p>
                                <div style={{ marginTop: '8px', fontSize: '0.75rem', color: '#888', display: 'flex', justifyContent: 'space-between' }}>
                                    <span>{new Date(item.published_at).toLocaleDateString()}</span>
                                    <span>{item.source}</span>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};

export default NewsWidget;
